import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postPresentSuccess = (params) => {
    return axios.post(`${backendHost}/api/admin/present/success`, params);
};

export {
    postPresentSuccess
}